import { getPersonalizedConfigOption } from "~/store/selectors/selector.configOptions.jsx";
import { getLoggedUser } from "~/store/selectors/selector.users";
import { editPersonalizedConfigOptions } from "../actions/actions.personalizedConfigOptions.jsx";

const userDefaultJobTypeIdMiddleware =
  ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    const { attributes = {} } = action;
    const { job_type_id, user_id } = attributes;
    const loggedUser = getLoggedUser(getState());

    const default_job_type_id = getPersonalizedConfigOption(getState(), `default_job_type_id`);

    if (
      typeof user_id === `number` &&
      loggedUser &&
      user_id === loggedUser.id &&
      typeof job_type_id === `number` &&
      job_type_id > 0 &&
      job_type_id !== default_job_type_id
    ) {
      dispatch(editPersonalizedConfigOptions({ default_job_type_id: job_type_id }));
    }

    return next(action);
  };

export default userDefaultJobTypeIdMiddleware;
